import DefaultTemplate from "./default";
import ContentHeader from "./ContentHeader";
import ContentFooter from "./ContentFooter";
// import HeroTemplate from "./hero";

const templates = {
  default: DefaultTemplate,
  contentHeader: ContentHeader,
  contentFooter: ContentFooter,
  // hero: HeroTemplate,
};

export function getTemplate(name) {
  if (!name || typeof name !== "string") {
    return templates.default;
  }

  return templates[name] || templates.default;
}
